import React, { FC, MouseEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IBaseComponent } from '../../sharedInterfaces/IBaseComponent';
import { nextPage, previousPage } from '~/actions/widgetContextActions';
import Button from '../Base/Button/Button';
import { pushToGTM } from '~/actions/gtmActions';
import { submitApplication } from '~/actions/submitActions';
import { IState } from '~/sharedInterfaces/IState';
import { getDefaultLabelName } from '~/services/DefaultLabelNameService';
import ComponentError from '../ComponentError/ComponentError';

export interface IPaginationButton {
  label?: string;
  noSubmit?: boolean;
}

interface IPaginationButtonProps extends IPaginationButton, IBaseComponent {}

const PaginationButton: FC<IPaginationButtonProps> = (props) => {
  const dispatch = useDispatch();
  const { widgetContext } = useSelector((state: IState) => state);
  const error = useSelector((state: IState) => state.error.serverError);
  const signupState = useSelector((state: IState) => state.signup);
  const { loading, settings, locale } = widgetContext;
  const { label, ...propsWithoutLabel } = props;

  const isLoanSubmitButton =
    props.componentName === 'next' && !props.noSubmit && settings.widgetType === 'loan';

  const isNextButtonLoading = loading && !props.noSubmit && props.componentName === 'next';
  let customLabel = label;

  // Temporary solution to handle limitation of missing PATCH functionality in the loan endpoint.
  if (!customLabel && isLoanSubmitButton) {
    customLabel = getDefaultLabelName(locale, 'submit').label;
  }

  const handler = (event: MouseEvent<HTMLInputElement>) => {
    event.preventDefault();
    dispatch(pushToGTM(`${props.componentName}-button-pressed`));
    if (props.componentName === 'next' && props.noSubmit) {
      dispatch(nextPage());
    } else if (props.componentName === 'next' && !props.noSubmit) {
      dispatch(submitApplication(settings.widgetType));
    } else {
      dispatch(previousPage());
    }
  };

  return (
    <>
      {error && props.componentName === 'next' && <ComponentError error={error} />}
      <Button
        {...propsWithoutLabel}
        label={customLabel}
        loading={isNextButtonLoading}
        disabled={!signupState.termsAgreement && !props.noSubmit}
        onClick={handler}
      />
    </>
  );
};

export default PaginationButton;
